import type { TOC } from '@ember/component/template-only';
import Modal from 'tio-reimagined/components/modal';
import Footer from 'tio-reimagined/components/footer';

export interface PdfModalSignature {
  Args: {
    show: boolean;
    onClose: () => void;
    closeButtonText?: string;
  };
  Blocks: {
    default: [];
  };
}

const TioPdfModal: TOC<PdfModalSignature> = <template>
  <Modal @isOpen={{@show}} @onClose={{@onClose}} class="min-h-64" @size="full">
    <:body>
      {{yield}}
    </:body>
    <:footer>
      <Footer
        @isRunning={{false}}
        @onSubmit={{@onClose}}
        @submitText={{if @closeButtonText @closeButtonText "Close Preview"}}
      />
    </:footer>
  </Modal>
</template>;

export default TioPdfModal;
